import { createAction, props } from '@ngrx/store';
import {
  Review,
  ReviewForm,
  ReviewsFilter
} from 'src/app/models/reviews.model';
import { User } from 'src/app/models/user.model';
import { ReviewsState } from '../reducers/reviews.reducer';

export const LOAD_REVIEWS = '[Reviews] Load Reviews';
export const LOAD_REVIEWS_SUCCESS = '[Reviews] Load Reviews success';
export const LOAD_REVIEWS_FAIL = '[Reviews] Load Reviews fail';
export const LOAD_REVIEWS_FORMS = '[Reviews] Load Reviews Forms';
export const LOAD_REVIEWS_FORMS_SUCCESS =
  '[Reviews] Load Reviews Forms success';
export const LOAD_REVIEWS_FORMS_FAIL = '[Reviews] Load Reviews Forms fail';
export const SELECT_PAYMENT = '[Reviews] Select Review';
export const UNSELECT_PAYMENT = '[Reviews] Unselect Review';
export const ADD_REVIEWS = '[Reviews] Add Reviews';
export const ADD_REVIEWS_SUCCESS = '[Reviews] Add Reviews success';
export const ADD_REVIEWS_FAIL = '[Reviews] Add Reviews fail';
export const EDIT_REVIEWS = '[Reviews] Edit Reviews';
export const EDIT_REVIEWS_SUCCESS = '[Reviews] Edit Reviews success';
export const EDIT_REVIEWS_FAIL = '[Reviews] Edit Reviews fail';
export const REMOVE_REVIEWS = '[Reviews] Remove Reviews';
export const REMOVE_REVIEWS_SUCCESS = '[Reviews] Remove Reviews success';
export const REMOVE_REVIEWS_FAIL = '[Reviews] Remove Reviews fail';
export const SELECT_TAB_INDEX_REVIEW = '[Reviews] Select Tab Index Review';
export const COMPLETE_REVIEWS = '[Reviews] Complete Reviews';
export const COMPLETE_REVIEWS_SUCCESS = '[Reviews] Complete Reviews success';
export const COMPLETE_REVIEWS_FAIL = '[Reviews] Complete Reviews fail';
export const SAVE_REVIEWS_FILTERS = '[Reviews] Save reviews filters';
export const CREATE_REVIEWS_SUCCESS = '[Reviews] Create Reviews success';
export const CREATE_REVIEWS_FAIL = '[Reviews] Create Reviews fail';

export const LoadReviewsAction = createAction(
  LOAD_REVIEWS,
  props<{ trainer: User; filters?: ReviewsFilter }>()
);

export const LoadReviewsSuccessAction = createAction(
  LOAD_REVIEWS_SUCCESS,
  props<{ data: Review[] }>()
);

export const LoadReviewsFailAction = createAction(
  LOAD_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const LoadReviewsFormsAction = createAction(
  LOAD_REVIEWS_FORMS,
  props<{ trainer: User }>()
);

export const LoadReviewsFormsSuccessAction = createAction(
  LOAD_REVIEWS_FORMS_SUCCESS,
  props<{ data: ReviewForm[] }>()
);

export const LoadReviewsFormsFailAction = createAction(
  LOAD_REVIEWS_FORMS_FAIL,
  props<{ error: Error }>()
);

export const SelectReviewAction = createAction(
  SELECT_PAYMENT,
  props<{ id: string }>()
);

export const UnselectReviewAction = createAction(UNSELECT_PAYMENT);

export const AddFormAction = createAction(
  ADD_REVIEWS,
  props<{ trainer: User; data: ReviewForm }>()
);

export const AddFormSuccessAction = createAction(
  ADD_REVIEWS_SUCCESS,
  props<{ data: ReviewForm }>()
);

export const AddFormFailAction = createAction(
  ADD_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const EditFormAction = createAction(
  EDIT_REVIEWS,
  props<{ trainer: User; data: ReviewForm }>()
);

export const EditFormSuccessAction = createAction(
  EDIT_REVIEWS_SUCCESS,
  props<{ data: ReviewForm }>()
);

export const EditFormFailAction = createAction(
  EDIT_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const RemoveFormAction = createAction(
  REMOVE_REVIEWS,
  props<{ id: string }>()
);

export const RemoveFormSuccessAction = createAction(
  REMOVE_REVIEWS_SUCCESS,
  props<{ id: string }>()
);

export const RemoveFormFailAction = createAction(
  REMOVE_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const SetTabIndexReviewAction = createAction(
  SELECT_TAB_INDEX_REVIEW,
  props<{ index: number }>()
);

export const CompleteReviewAction = createAction(
  COMPLETE_REVIEWS,
  props<{ review: Review }>()
);

export const CompleteReviewSuccessAction = createAction(
  COMPLETE_REVIEWS_SUCCESS,
  props<{ data: Review }>()
);

export const CompleteReviewFailAction = createAction(
  COMPLETE_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const SaveReviewsFilters = createAction(
  SAVE_REVIEWS_FILTERS,
  props<{ filters: ReviewsFilter }>()
);

export const CreateReviewSuccessAction = createAction(CREATE_REVIEWS_SUCCESS);

export const CreateReviewFailAction = createAction(
  CREATE_REVIEWS_FAIL,
  props<{ error: Error }>()
);

export const getReviewsData = (state: ReviewsState) => state.data;
export const getReviewsIsLoading = (state: ReviewsState) => state.loading;
export const getReviewsError = (state: ReviewsState) => state.error;
